import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    listItem: {
      width: '100%',
    },
    historyItem: {
      minWidth: 0,
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75),
      '& .MuiListItemText-root': {
        minWidth: 0,
        margin: 0,
      },
      '& $primaryText': {
        overflowWrap: 'anywhere',
        lineHeight: 1.35,
      },
      '& $secondaryContainer': {
        flexWrap: 'wrap',
        columnGap: theme.spacing(1.5),
        rowGap: theme.spacing(0.25),
        marginTop: theme.spacing(0.25),
      },
      '& $ordersText, & $earnedText': {
        minWidth: 0,
        maxWidth: '100%',
        overflowWrap: 'anywhere',
        lineHeight: 1.5,
        fontVariantNumeric: 'tabular-nums',
      },
      '& $divider': {
        display: 'none',
      },
    },
    compensationDetails: {
      minWidth: 0,
      maxWidth: '100%',
      marginTop: theme.spacing(0.25),
      fontSize: 12,
      color: theme.palette.text.secondary,
      overflowWrap: 'anywhere',
      '& summary': {
        cursor: 'pointer',
        width: 'fit-content',
        maxWidth: '100%',
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
      },
      '& summary:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
        borderRadius: 2,
      },
      '& p': {
        margin: 0,
        paddingBottom: theme.spacing(0.5),
        fontSize: 'inherit',
      },
    },
    primaryText: {
      fontWeight: 500,
      color: '#000000DE',
      fontSize: 16,
    },
    secondaryContainer: {
      fontSize: 12,
      display: 'flex',
      alignItems: 'center',
    },
    activeText: {
      fontSize: 12,
      color: ({ status }) =>
        theme.palette.driverStatus?.[status] || theme.palette.primary.main,
    },
    ordersText: {
      fontSize: 12,
    },
    earnedText: {
      fontSize: 12,
    },
    boldText: {
      fontWeight: 'bold',
    },
    divider: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      borderRadius: 1,
      width: 2,
      height: 2,
      background: '#0000008A 0% 0% no-repeat padding-box',
    },
    driverAvatar: {
      color: '#212121',
      border: '2px solid #2176EA',
      borderColor: ({ status }) =>
        theme.palette.driverStatus?.[status] || theme.palette.primary.main,
      background: '#EBEBEB 0% 0% no-repeat padding-box',
    },
    rightIcon: {
      color: '#212121',
    },
  })
);
